import {
    Box,
    Drawer,
    List,
    Typography,
    Divider,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Tooltip,
    Collapse,
    Paper,
    alpha,
    useMediaQuery,
} from '@mui/material';
import {
    Dashboard as DashboardIcon,
    People as PeopleIcon,
    Settings as SettingsIcon,
    ChevronLeft as ChevronLeftIcon,
    ExpandLess as ExpandLessIcon,
    ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';
import { useState, useRef, useEffect } from 'react';



//ICONOS PARA MENU
import  dashboardIcon  from '../../assets/dashboard.png';
import  activosIcon  from '../../assets/activos.png';
import  locationIcon  from '../../assets/location.png';
import  equipoIcon  from '../../assets/equipo.png';
import  insumoIcon  from '../../assets/insumo.png';
import  usuarioIcon  from '../../assets/usuario.png';
import  tareasIcon  from '../../assets/tareas.png';
import  tareaProgramadaIcon  from '../../assets/tareaProgramada.png';
import  ordenTrabajoIcon  from '../../assets/ordenTrabajo.png';
import todosIcon from '../../assets/todos.png';
import inventarioIcon from '../../assets/inventario-disponible.png';
import rolIcon from '../../assets/rol.png';
import ListUsuarios from '../../assets/list_users.png';

const menuItems = [
    { text: 'Dashboard', icon: <img src={dashboardIcon} alt="dashboard" style={{width: '25px', height: '25px'}}/>, path: '/', miniText: "DASH", 
        permissions: { action: 'read', resource: ['DASHBOARD.ADMIN', 'DASHBOARD.AUX'] }
    },
    { text: 'Activos', icon: <img src={activosIcon} alt="activos" style={{width: '25px', height: '25px'}}/>, path: '/activos', miniText: "ACTIVOS",
        permissions: { action: 'read', resource: ['ASSETS.EQUIPMENTS', 'ASSETS.LOCATIONS'] },
        children: [
            { text: 'Equipos', icon: <img src={equipoIcon} alt="equipo" style={{width: '25px', height: '25px'}}/>, path: '/activos/equipos', permissions: { action: 'read', resource: 'ASSETS.EQUIPMENTS' } },
            { text: 'Ubicaciones', icon: <img src={locationIcon} alt="location" style={{width: '25px', height: '25px'}}/>, path: '/activos/ubicaciones', permissions: { action: 'read', resource: 'ASSETS.LOCATIONS' } },
            
            //{ text: 'Todos', icon: <img src={todosIcon} alt="todos" style={{width: '25px', height: '25px'}}/>, path: '/activos' },
        ]
     },
     {
        text: 'Inventario',
        icon: <img src={inventarioIcon} alt="inventario" style={{width: '25px', height: '25px'}}/>,
        path: '/inventario',
        miniText: "INVENTARIO",
        permissions: { action: 'read', resource: ['RESOURCES'] },
        children: [
            { text: 'Insumos', icon: <img src={insumoIcon} alt="insumo" style={{width: '25px', height: '25px'}}/>, path: '/insumos', permissions: { action: 'read', resource: 'RESOURCES' } },
        ]
     },
    { text: 'Usuarios', icon: <img src={usuarioIcon} alt="usuario" style={{width: '25px', height: '25px'}}/>, path: '/rrhh', miniText: "USERS",
        permissions: { action: 'read', resource: ['ROLES', 'USERS'] },
        children: [
            { text: 'Usuarios', icon: <img src={ListUsuarios} alt="usuario" style={{width: '25px', height: '25px'}}/>, path: '/rrhh', permissions: { action: 'read', resource: 'ROLES' } },
            { text: 'Roles', icon: <img src={rolIcon} alt="rol" style={{width: '25px', height: '25px'}}/>, path: '/rrhh/roles', permissions: { action: 'read', resource: 'ROLES' } },
        ]
     },
    { text: 'Tareas', icon: <img src={tareasIcon} alt="tareas" style={{width: '25px', height: '25px'}}/>, path: '/dashboard/tareas', miniText: "TAREAS",
        permissions: { action: 'read', resource: ['TASKS', 'OTS'] },
        children: [
            { text: 'Plan de tareas', icon: <img src={tareaProgramadaIcon} alt="tarea" style={{width: '25px', height: '25px'}}/>, path: '/task/scheduled', permissions: { action: 'read', resource: 'SCHEDULED.PLANNING' } },
            { text: 'Ordenes de trabajo', icon: <img src={ordenTrabajoIcon} alt="reporte" style={{width: '25px', height: '25px'}}/>, path: '/task/wo', permissions: { action: 'read', resource: 'TASK' } },
        ]
     },
];

import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { useAbility } from '../../shared/context/AbilityContext';






const Sidebar = ({ open, onClose, drawerWidth }) => {
    const theme = useTheme();
    const [expandedItems, setExpandedItems] = useState({});
    const [hoveredItem, setHoveredItem] = useState(null);
    const [submenuPosition, setSubmenuPosition] = useState(0);
    const [activeItem, setActiveItem] = useState('');
    const sidebarRef = useRef(null);
    const navigate = useNavigate();
    // Detectar si la pantalla es de tamaño móvil
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const ability = useAbility();

    // Función para verificar permisos
    const checkPermissions = (permissions) => {
        if (!permissions) return true;
        
        const { action, resource } = permissions;
        
        // Si resource es un array, verificar cada recurso
        if (Array.isArray(resource)) {
            return resource.some(res => ability.can(action, res));
        }
        
        // Si es un solo recurso
        return ability.can(action, resource);
    };

    // Cerrar submenús cuando cambia el estado del drawer
    useEffect(() => {
        setHoveredItem(null);
    }, [open]);

    // Set active item based on current path
    useEffect(() => {
        const path = window.location.pathname;
        setActiveItem(path);
    }, []);
    
    const handleToggleExpand = (itemText) => {
        setExpandedItems(prev => ({
            ...prev,
            [itemText]: !prev[itemText]
        }));
    };

    const handleItemMouseEnter = (item, event) => {
        if (!open && item.children) {
            // Calcular la posición vertical del submenú
            const rect = event.currentTarget.getBoundingClientRect();
            setSubmenuPosition(rect.top);
            setHoveredItem(item);
        }
    };

    const handleItemMouseLeave = () => {
        // No hacer nada, el submenú se controlará con su propio hover
    };

    const handleSubMenuMouseLeave = () => {
        setHoveredItem(null);
    };

    const navigateTo = (path) => {
        setActiveItem(path);
        navigate(path);
    };

    const isItemActive = (itemPath, isChildItem = false) => {
        // Si es un elemento hijo, solo debe estar activo si coincide exactamente con la ruta actual
        if (isChildItem) {
            return activeItem === itemPath;
        }
        
        // Para elementos padre sin hijos, solo debe estar activo si coincide exactamente
        const item = menuItems.find(item => item.path === itemPath);
        if (!item?.children) {
            return activeItem === itemPath;
        }
        
        // Para elementos padre con hijos, debe estar activo solo si estamos en su ruta exacta
        // (no en la ruta de uno de sus hijos)
        return activeItem === itemPath;
    };
    
    // Verificar si algún hijo de un elemento está activo
    const hasActiveChild = (item) => {
        if (!item.children) return false;
        return item.children.some(child => activeItem === child.path);
    };

    const renderMenuItem = (item) => {
        // Verificar permisos antes de renderizar
        if (!checkPermissions(item.permissions)) {
            return null;
        }

        // Si el item tiene hijos, verificar si al menos uno tiene permisos
        if (item.children) {
            const hasVisibleChildren = item.children.some(child => checkPermissions(child.permissions));
            if (!hasVisibleChildren) {
                return null;
            }
        }

        const hasChildren = item.children && item.children.length > 0;
        const isExpanded = expandedItems[item.text] || false;
        const isHovered = hoveredItem === item;
        const isActive = isItemActive(item.path);
        const hasChildActive = hasActiveChild(item);

        return (
            <Box 
                key={item.text} 
                position="relative"
                onMouseEnter={(e) => handleItemMouseEnter(item, e)}
                onMouseLeave={handleItemMouseLeave}
                sx={{ mb: 0.5 }}
            >
                <ListItem disablePadding>
                    <Tooltip title={!open ? item.text : ''} placement="right" arrow>
                        <ListItemButton
                            onClick={() => {
                                if (open && hasChildren) {
                                    handleToggleExpand(item.text);
                                } else if (!hasChildren) {
                                    navigateTo(item.path);
                                }
                            }}
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? 'initial' : 'center',
                                px: open ? 2.5 : 1,
                                position: 'relative',
                                borderRadius: '8px',
                                mx: open ? 1 : 0.5,
                                transition: 'all 0.2s ease-in-out',
                                display: 'flex',
                                alignItems: 'center',
                                background: isActive ? 
                                    `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.primary.main, 0.2)} 100%)` : 
                                    hasChildActive ? 
                                    alpha(theme.palette.primary.main, 0.05) :
                                    'transparent',
                                '&:hover': {
                                    background: !isActive ? 
                                        alpha(theme.palette.primary.main, 0.04) : 
                                        `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.primary.main, 0.25)} 100%)`,
                                },
                                '&::before': (isActive || hasChildActive) && open ? {
                                    content: '""',
                                    position: 'absolute',
                                    left: 0,
                                    top: '20%',
                                    height: '60%',
                                    width: '4px',
                                    backgroundColor: isActive ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.5),
                                    borderRadius: '0 4px 4px 0',
                                } : {},
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : 'auto',
                                    ml: !open ? 'auto' : 0,
                                    justifyContent: 'center',
                                    flexDirection: !open ? 'column' : 'row',
                                    alignItems: 'center',
                                    width: !open ? '100%' : 'auto',
                                    textAlign: 'center',
                                    "& .MuiSvgIcon-root": {
                                        fontSize: '20px',
                                    },
                                    "& img": {
                                        filter: (isActive || hasChildActive) ? 'brightness(0.8) saturate(1.5)' : 'none',
                                        transition: 'all 0.2s ease',
                                        width: !open ? '30px' : '25px',
                                        height: !open ? '30px' : '25px',
                                        display: 'block',
                                        margin: !open ? '0 auto' : '0',
                                    },
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: !open ? '100%' : 'auto',
                                }}>
                                    {item.icon}
                                </div>
                                {!open && <div style={{
                                    fontSize: '10px',
                                    fontWeight: (isActive || hasChildActive) ? '700' : '500',
                                    lineHeight: 1,
                                    textAlign: 'center',
                                    width: '100%',
                                    color: (isActive || hasChildActive) ? theme.palette.primary.main : theme.palette.text.secondary,
                                    marginTop: '5px',
                                    transition: 'all 0.2s ease',
                                }}>
                                    {item.miniText}
                                </div>}
                            </ListItemIcon>
                            <ListItemText 
                                primary={item.text} 
                                sx={{ 
                                    opacity: open ? 1 : 0,
                                    "& .MuiListItemText-primary": {
                                        fontSize: '14px',
                                        fontWeight: (isActive || hasChildActive) ? '600' : '500',
                                        color: (isActive || hasChildActive) ? theme.palette.primary.main : theme.palette.text.primary,
                                        transition: 'all 0.2s ease',
                                    } 
                                }}
                            />
                            {hasChildren && open && (
                                <IconButton 
                                    size="small" 
                                    sx={{ 
                                        ml: 1,
                                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s',
                                        color: (isActive || hasChildActive) ? theme.palette.primary.main : theme.palette.text.secondary,
                                    }}
                                >
                                    <ExpandMoreIcon fontSize="small" />
                                </IconButton>
                            )}
                        </ListItemButton>
                    </Tooltip>
                </ListItem>

                {/* Submenú desplegable dentro del drawer */}
                {hasChildren && open && (
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding sx={{ mt: 0.5 }}>
                            {item.children
                                .filter(child => checkPermissions(child.permissions))
                                .map((child) => {
                                    const isChildActive = isItemActive(child.path, true);
                                    return (
                                        <ListItem key={child.text} disablePadding>
                                            <Tooltip title={!open ? child.text : ''} placement="right" arrow>
                                                <ListItemButton
                                                    onClick={() => navigateTo(child.path)}
                                                    sx={{
                                                        pl: 3,
                                                        minHeight: 40,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        ml: 3,
                                                        mr: 1,
                                                        borderRadius: '8px',
                                                        transition: 'all 0.2s ease',
                                                        background: isChildActive ? 
                                                            alpha(theme.palette.primary.main, 0.08) : 
                                                            'transparent',
                                                        '&:hover': {
                                                            background: !isChildActive ? 
                                                                alpha(theme.palette.primary.main, 0.04) : 
                                                                alpha(theme.palette.primary.main, 0.12),
                                                        },
                                                    }}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: 0,
                                                            mr: open ? 2 : 'auto',
                                                            justifyContent: 'center',
                                                            "& .MuiSvgIcon-root": {
                                                                fontSize: '18px',
                                                            },
                                                            "& img": {
                                                                filter: isChildActive ? 'brightness(0.8) saturate(1.5)' : 'none',
                                                                transition: 'all 0.2s ease',
                                                                width: '22px',
                                                                height: '22px',
                                                            }
                                                        }}
                                                    >
                                                        {child.icon}
                                                    </ListItemIcon>
                                                    <ListItemText 
                                                        primary={child.text} 
                                                        sx={{ 
                                                            opacity: open ? 1 : 0, 
                                                            "& .MuiListItemText-primary": {
                                                                fontSize: '14px',
                                                                fontWeight: isChildActive ? '600' : '400',
                                                                color: isChildActive ? theme.palette.primary.main : theme.palette.text.secondary,
                                                                transition: 'all 0.2s ease',
                                                            } 
                                                        }}
                                                    />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </Collapse>
                )}

                {/* Submenú flotante para la versión mini */}
                {!open && hasChildren && isHovered && (
                    <Paper
                        elevation={8}
                        sx={{
                            position: 'fixed',
                            left: '65px',
                            width: '200px',
                            zIndex: 1300,
                            top: submenuPosition,
                            borderRadius: '12px',
                            bgcolor: theme.palette.background.paper,
                            overflow: 'hidden',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                            animation: 'fadeIn 0.2s ease-in-out',
                            '@keyframes fadeIn': {
                                '0%': {
                                    opacity: 0,
                                    transform: 'translateX(-10px)'
                                },
                                '100%': {
                                    opacity: 1,
                                    transform: 'translateX(0)'
                                }
                            }
                        }}
                        onMouseEnter={() => setHoveredItem(item)}
                        onMouseLeave={handleSubMenuMouseLeave}
                    >
                        <List sx={{ py: 1 }}>
                            {item.children
                                .filter(child => checkPermissions(child.permissions))
                                .map((child) => {
                                    const isChildActive = isItemActive(child.path, true);
                                    return (
                                        <ListItem key={child.text} disablePadding>
                                            <ListItemButton
                                                onClick={() => navigateTo(child.path)}
                                                sx={{
                                                    py: 1,
                                                    minHeight: 36,
                                                    mx: 1,
                                                    borderRadius: '8px',
                                                    transition: 'all 0.2s ease',
                                                    background: isChildActive ? 
                                                        alpha(theme.palette.primary.main, 0.08) : 
                                                        'transparent',
                                                    '&:hover': {
                                                        background: !isChildActive ? 
                                                            alpha(theme.palette.primary.main, 0.04) : 
                                                            alpha(theme.palette.primary.main, 0.12),
                                                    },
                                                }}
                                            >
                                                <ListItemIcon 
                                                    sx={{ 
                                                        minWidth: 36, 
                                                        "& img": {
                                                            filter: isChildActive ? 'brightness(0.8) saturate(1.5)' : 'none',
                                                            transition: 'all 0.2s ease',
                                                            width: '22px',
                                                            height: '22px',
                                                        }
                                                    }}
                                                >
                                                    {child.icon}
                                                </ListItemIcon>
                                                <ListItemText 
                                                    primary={child.text} 
                                                    primaryTypographyProps={{ 
                                                        fontSize: '13px',
                                                        fontWeight: isChildActive ? '600' : '400',
                                                        color: isChildActive ? theme.palette.primary.main : theme.palette.text.primary,
                                                    }}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </Paper>
                )}
            </Box>
        );
    };

    return (
        <Drawer
            variant={isMobile ? "temporary" : "permanent"}
            open={open}
            onClose={onClose}
            sx={{
                width: open ? drawerWidth : 80,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? drawerWidth : 80,
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',
                    borderRadius: '0px',
                    overflowX: 'hidden',
                    transition: theme => theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    boxShadow: '0 3px 10px rgba(0,0,0,0.08)',
                    border: 'none',
                    zIndex: 100,
                },
                [theme.breakpoints.down('sm')]: {
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                    },
                },
            }}
        >
            <Box 
                ref={sidebarRef}
                sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    background: theme.palette.mode === 'light' 
                        ? 'linear-gradient(180deg, rgba(250,252,254,1) 0%, rgba(255,255,255,1) 100%)' 
                        : 'linear-gradient(180deg, rgba(18,18,18,1) 0%, rgba(30,30,30,1) 100%)',
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'flex-end',
                    padding: '16px'
                }}>
                    <IconButton 
                        onClick={onClose}
                        sx={{
                            background: alpha(theme.palette.primary.main, 0.04),
                            '&:hover': {
                                background: alpha(theme.palette.primary.main, 0.08),
                            },
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
                <Divider sx={{ opacity: 0.6 }} />
                <List sx={{ 
                    flexGrow: 1, 
                    pt: 2,
                    px: 0.5,
                }}>
                    <ListItem key="dashboard" disablePadding sx={{
                        "& .MuiListItem-root": {
                            backgroundColor: theme.palette.background.paper,
                        }
                    }}>
                        <ListItemText primary={
                            <Typography 
                                variant="span" 
                                noWrap 
                                component="div" 
                                sx={{
                                    fontSize: '12px',
                                    textAlign: 'left',    
                                    color: alpha(theme.palette.text.primary, 0.7),
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    fontWeight: 600,
                                    pl: 3,
                                }}
                            >
                                Menu items
                            </Typography>
                        }
                        sx={{
                            display: open ? 'block' : 'none',
                            padding: '4px 0 12px', 
                        }}
                        />
                    </ListItem>
                    {menuItems.map((item) => renderMenuItem(item))}
                </List>
            </Box>
        </Drawer>
    );
};

export default Sidebar; 